if (!customElements.get('product-tab-description')) {
  customElements.define(
    'product-tab-description',
    class ProductTabDescriptionComponent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.showMoreBtn = this.querySelector('.description__show-more-btn');

        if (this.showMoreBtn) {
          this.init();
        }
      }

      init() {
        this.addShowMoreClickListener();
      }

      addShowMoreClickListener() {
        this.showMoreBtn.addEventListener('click', () => this.handleShowMoreClick());
      }

      handleShowMoreClick() {
        const descriptionElem = this.showMoreBtn.closest('.description');
        if (!descriptionElem) return;

        descriptionElem.classList.remove('description--max-visible-eight-lines');

        const overlayElem = descriptionElem.querySelector('.description__overlay');
        if (overlayElem) overlayElem.classList.add('hidden');

        const showMoreBtnWrapper = this.showMoreBtn.closest('.description__show-more-btn-wrapper');
        if (showMoreBtnWrapper) showMoreBtnWrapper.classList.add('hidden');
      }
    }
  );
}
